import { ShoppingCart, Pill, Fuel, Croissant, Wrench, Utensils, Shirt, Hammer, Stethoscope, Glasses, Baby, Dog, IceCream, HeartPulse, Cake, Flower2, Droplets, Scissors } from 'lucide-react';
import React from 'react';

export interface ComercioItem {
  name: string;
  number: string;
  whatsapp?: string;
  address?: string;
  app?: string;
  description?: string;
}

export interface ComercioCategory {
  id: string;
  category: string;
  icon: React.ReactNode;
  color: string;
  items: ComercioItem[];
}

export const COMERCIO_DATA: ComercioCategory[] = [
  {
    id: "barbearias",
    category: "Barbearias",
    icon: <Scissors className="w-8 h-8" />,
    color: "bg-zinc-800",
    items: [
      { 
        name: "VICTRIX BARBEARIA (ANDRÉ TOMAZZINI KULTZ)", 
        number: "(45) 99908-4638", 
        whatsapp: "https://wa.me/5545999084638", 
        address: "Av. dos Pioneiros, 585, Catanduvas PR, 85470-000",
        description: "Barbearia com serviços completos de corte masculino e barba em Catanduvas."
      },
      { 
        name: "JK Barbeiros", 
        number: "(45) 99908-4638", 
        whatsapp: "https://wa.me/5545999084638", 
        address: "Av. Oito de Dezembro, Catanduvas PR, 85470-000",
        description: "Barbearia tradicional com atendimento local e cortes masculinos."
      },
      { 
        name: "Guego Cabelo e Barba", 
        number: "(45) 9106-2601", 
        whatsapp: "https://wa.me/554591062601", 
        address: "Av. Paraná, 318, Catanduvas PR, 85470-000",
        description: "Serviços de corte de cabelo e barba com atendimento em Catanduvas."
      },
      { 
        name: "Barbearia Hoffmann", 
        number: "(45) 98807-0565", 
        whatsapp: "https://wa.me/5545988070565", 
        address: "Avenida Adolfo Chagas, Alto Alegre, Catanduvas PR",
        description: "Barbearia com atendimento masculino, oferecendo cortes e serviços de barba."
      }
    ]
  },
  {
    id: "agroveterinarias",
    category: "Agroveterinárias",
    icon: <Dog className="w-8 h-8" />,
    color: "bg-orange-800",
    items: [
      { name: "Casa do Produtor", number: "(45) 99128-8393", whatsapp: "https://wa.me/5545991288393", address: "Av. Adolfo Chagas, 407, Centro, Catanduvas PR" },
      { name: "Casa do Campo", number: "(45) 99145-7754", whatsapp: "https://wa.me/5545991457754", address: "Av. Paraná, 414, Centro, Catanduvas PR" },
      { name: "Agropecuária Braço Forte", number: "(45) 3234-1621", whatsapp: "https://wa.me/554532341621", address: "Av. Augusto Gomes de Oliveira, 633, Centro, Catanduvas PR" },
      { name: "Nosso Chão Agropecuária", number: "(45) 3234-1549", whatsapp: "https://wa.me/554532341549", address: "Av. Paraná, 461, Centro, Catanduvas PR" },
    ]
  },
  {
    id: "borracharias",
    category: "Borracharias",
    icon: <Wrench className="w-8 h-8" />,
    color: "bg-stone-600",
    items: [
      { 
        name: "Borracharia dos Amigos", 
        number: "(45) 99131-5866", 
        whatsapp: "https://wa.me/5545991315866", 
        address: "Rua Angelina C dos Santos, 413, Cavechão dos Santos, Catanduvas PR, CEP 85470-000",
        description: "Serviços de reparo e troca de pneus. Atendimento fora do horário comercial"
      },
      { 
        name: "Borracharia do Gelson", 
        number: "(45) 9836-8343", 
        whatsapp: "https://wa.me/554598368343", 
        address: "PR-471, Anexo ao Posto São João, Catanduvas PR",
        description: "Serviços de reparo e troca de pneus"
      },
      { 
        name: "Borracharia Rotta 277", 
        number: "(45) 99904-2133", 
        whatsapp: "https://wa.me/5545999042133", 
        address: "BR-277, km 550, Adelainha, Catanduvas PR, CEP 85470-000",
        description: "Serviços de reparo e troca de pneus. Atendimento 24 horas"
      }
    ]
  },
  {
    id: "clinicas-medicas",
    category: "Clínicas Médicas",
    icon: <HeartPulse className="w-8 h-8" />,
    color: "bg-rose-600",
    items: [
      { name: "CLÍNICA MARIO KENJI MURAOKA", number: "(45) 9999-5304", whatsapp: "https://wa.me/554599995304", address: "RUA PADRE FELIPE, 375, CENTRO, CATANDUVAS PR" },
      { name: "CLÍNICA ESPAÇO SAÚDE", number: "(45) 99154-4057", whatsapp: "https://wa.me/5545991544057", address: "Avenida dos Pioneiros, 604, Catanduvas, PR" },
    ]
  },
  {
    id: "construcao-ferragens",
    category: "Construção e Ferragens",
    icon: <Hammer className="w-8 h-8" />,
    color: "bg-slate-700",
    items: [
      { name: "G Santin Materiais de Construção", number: "(45) 3234-1349", whatsapp: "https://wa.me/554532341349", address: "Av. dos Pioneiros, 619, Catanduvas PR" },
      { name: "Lojas Quero-Quero Catanduvas", number: "(44) 99178-5519", whatsapp: "https://wa.me/5544991785519", address: "Av. Paraná, 309, Centro, Catanduvas PR" },
      { name: "Lagos Materiais de Construção", number: "(45) 99132-5484", whatsapp: "https://wa.me/5545991325484", address: "Av. Augusto Gomes de Oliveira, 674, Catanduvas PR" },
      { name: "Pavan Materiais de Construção", number: "(45) 99972-0384", whatsapp: "https://wa.me/5545999720384", address: "Av. Adolfo Chagas, 417, Alto Alegre, Catanduvas PR" },
    ]
  },
  {
    id: "dentistas",
    category: "Dentistas",
    icon: <Stethoscope className="w-8 h-8" />,
    color: "bg-cyan-600",
    items: [
      { name: "Scaranto Odontologia", number: "(45) 99944-1934", whatsapp: "https://wa.me/5545999441934", address: "Av. dos Pioneiros, 627, Catanduvas PR" },
      { name: "Enokida Odontologia", number: "(45) 99902-6266", whatsapp: "https://wa.me/5545999026266", address: "Av. dos Pioneiros, 628, Centro, Catanduvas PR" },
      { name: "Consultório Odontológico Dr. Paulo Machado", number: "(45) 99138-6844", whatsapp: "https://wa.me/5545991386844", address: "Rua Presidente Kennedy, 480, Centro, Catanduvas PR" },
      { name: "Consultório DR. Helio Yonekura", number: "(45) 99129-5657", whatsapp: "https://wa.me/5545991295657", address: "Rua Pres. Costa e Silva, 564, Centro, Catanduvas PR" },
      { name: "Dra Flávia Dallestel", number: "Não informado", address: "R. Prof. Adauto, Catanduvas PR" },
    ]
  },
  {
    id: "farmacias",
    category: "Farmácias",
    icon: <Pill className="w-8 h-8" />,
    color: "bg-emerald-600",
    items: [
      { name: "Farmácia Ultra Descontão", number: "(45) 99155-1419", whatsapp: "https://wa.me/5545991551419", address: "Av. dos Pioneiros, 568, Centro, Catanduvas PR" },
      { name: "FarmaCenter", number: "(45) 99147-9671", whatsapp: "https://wa.me/5545991479671", address: "Av. dos Pioneiros, 615, Catanduvas PR" },
      { name: "Farmácias Brava Catanduvas", number: "(45) 99142-0642", whatsapp: "https://wa.me/5545991420642", address: "Av. Paraná, 359, Catanduvas PR" },
      { name: "Farmácia Santa Maria", number: "(45) 99155-8710", whatsapp: "https://wa.me/5545991558710", address: "Av. dos Pioneiros, 557, Catanduvas PR" },
      { name: "Farmácia Alto Alegre", number: "(45) 98800-1093", whatsapp: "https://wa.me/5545988001093", address: "Av. Adolfo Chagas, 491, Alto Alegre, Catanduvas PR" },
      { name: "Farmácia Catanduvas", number: "(45) 99849-2652", whatsapp: "https://wa.me/5545998492652", address: "Av. dos Pioneiros, 521, Catanduvas PR" },
    ]
  },
  {
    id: "lavacar",
    category: "Lava car",
    icon: <Droplets className="w-8 h-8" />,
    color: "bg-cyan-700",
    items: [
      { 
        name: "Pistoris Lavacar (Marcelo Lavacar)", 
        number: "(45) 99999-5920", 
        whatsapp: "https://wa.me/5545999995920", 
        address: "Rua Antonio Alves Vaz, 455, Alto Alegre, Catanduvas PR, 85471-039",
        description: "Lava car com atendimento em Catanduvas, oferecendo serviços de limpeza automotiva"
      },
      { 
        name: "Lavacar Oliveira", 
        number: "(45) 99945-4169", 
        whatsapp: "https://wa.me/5545999454169", 
        address: "Av. Augusto Gomes de Oliveira, Catanduvas PR, 85470-000",
        description: "Lava car com serviço completo de limpeza automotiva, atendimento local"
      }
    ]
  },
  {
    id: "oticas",
    category: "Óticas",
    icon: <Glasses className="w-8 h-8" />,
    color: "bg-indigo-600",
    items: [
      { name: "Ótica e Cia Gold", number: "(45) 99940-5081", whatsapp: "https://wa.me/5545999405081", address: "Av. dos Pioneiros, 604, Centro, Catanduvas PR" },
      { name: "Ótica Quero Ver", number: "(45) 99827-5758", whatsapp: "https://wa.me/5545998275758", address: "Av. Paraná, 335, Centro, Catanduvas PR" },
    ]
  },
  {
    id: "floricultura",
    category: "Floricultura",
    icon: <Flower2 className="w-8 h-8" />,
    color: "bg-emerald-700",
    items: [
      { name: "Inove Floricultura e Estufas Agrícolas", number: "(45) 99142-4031", whatsapp: "https://wa.me/5545991424031", address: "Av. dos Pioneiros, 529, Centro, Catanduvas PR" },
    ]
  },
  {
    id: "panificadoras",
    category: "Panificadoras",
    icon: <Croissant className="w-8 h-8" />,
    color: "bg-amber-600",
    items: [
      { 
        name: "Panificadora e Confeitaria BIG Pão", 
        number: "(45) 98801-7731", 
        whatsapp: "https://wa.me/5545988017731", 
        address: "Av. Paraná, 347, Centro, Catanduvas PR" 
      },
      { 
        name: "Padaria e Confeitaria Delícias da Casa", 
        number: "(45) 99818-2608", 
        whatsapp: "https://wa.me/5545998182608", 
        address: "Av. Brasil, 576, Centro, Catanduvas PR" 
      },
      { 
        name: "Panificadora e Confeitaria Casa do Pão", 
        number: "(45) 98485-5002", 
        whatsapp: "https://wa.me/5545984855002", 
        address: "Av. Oito de Dezembro, 452, Bairro Alto Alegre, Catanduvas PR" 
      }
    ]
  },
  {
    id: "postos-combustivel",
    category: "Postos de Combustível",
    icon: <Fuel className="w-8 h-8" />,
    color: "bg-amber-600",
    items: [
      { name: "Posto São João", number: "(45) 3234-1382", whatsapp: "https://wa.me/554532341382", address: "Av. Augusto Gomes de Oliveira, 171, Catanduvas PR" },
      { name: "Posto Vissoto", number: "(45) 92002-7520", whatsapp: "https://wa.me/5545920027520", address: "PR-471, Catanduvas PR" },
      { name: "Auto Posto Valduga", number: "(45) 99145-1714", whatsapp: "https://wa.me/5545991451714", address: "Av. Brasil, 348, Catanduvas PR" },
    ]
  },
  {
    id: "restaurantes-lanchonetes",
    category: "Restaurantes e Lanchonetes",
    icon: <Utensils className="w-8 h-8" />,
    color: "bg-red-600",
    items: [
      { 
        name: "A Cantina", 
        number: "(45) 99152-3513", 
        whatsapp: "https://wa.me/5545991523513", 
        address: "Rua Presidente Kennedy esquina com Rua Presidente Castelo Branco, Centro, Catanduvas PR",
        app: "https://app.anota.ai/m/5Mn7h9wcw"
      },
      { 
        name: "Buteko's Lanches", 
        number: "(45) 99146-9119", 
        whatsapp: "https://wa.me/554591469119", 
        address: "Avenida Paraná, Centro, Catanduvas PR" 
      },
      { 
        name: "Bora Bora Pizzaria", 
        number: "(45) 99983-2084", 
        whatsapp: "https://wa.me/5545999832084", 
        address: "Rua Rio Grande do Sul, Loteamento Dona Bela, Catanduvas PR",
        app: "https://pedido.anota.ai/loja/bora-bora-choperia-1"
      },
      { 
        name: "Duffeck Pizzaria", 
        number: "(45) 99830-3057", 
        whatsapp: "https://wa.me/5545998303057", 
        address: "Rua Presidente Kennedy, Centro, Catanduvas PR",
        app: "https://akitem.app/duffeckpizzaria"
      },
      { 
        name: "Pizzaria Monteiro", 
        number: "(45) 99146-9362", 
        whatsapp: "https://wa.me/554591469362", 
        address: "Rua Duque de Caxias, Bairro Menino Deus, Catanduvas PR"
      },
      { 
        name: "Pizzaria Paladar", 
        number: "(45) 98407-1778", 
        whatsapp: "https://wa.me/5545984071778", 
        address: "Rua Dom Pedro II, Catanduvas PR"
      },
      { 
        name: "Pizzaria Pedrinho", 
        number: "(45) 99920-9183", 
        whatsapp: "https://wa.me/5545999209183", 
        address: "Av. Adolfo Chagas, 449, Bairro Alto Alegre, Catanduvas PR",
        app: "https://pedir.delivery/app/pizzariapedrinho/menu"
      },
      { 
        name: "Mega Beer Restaurante (fogão a lenha)", 
        number: "(45) 99132-9934", 
        whatsapp: "https://wa.me/5545991329934", 
        address: "Avenida Augusto Gomes de Oliveira, PR-471, 760, Alto Alegre, Catanduvas PR" 
      },
      { 
        name: "Restaurante Costa e Silva", 
        number: "(45) 3234-1380", 
        whatsapp: "https://wa.me/554532341380", 
        address: "Rua Presidente Costa e Silva, 432, Bairro Menino Deus, Catanduvas PR" 
      },
      { 
        name: "Restaurante Tempero Bom", 
        number: "(45) 99124-0950", 
        whatsapp: "https://wa.me/5545991240950", 
        address: "Av. Augusto Gomes de Oliveira, 700, Catanduvas PR" 
      },
      { 
        name: "Nonna Oliva", 
        number: "(45) 99149-2717", 
        whatsapp: "https://wa.me/5545991492717", 
        address: "Av. Paraná, 412, Centro, Catanduvas PR, CEP 85470-000" 
      }
    ]
  },
  {
    id: "sorveterias",
    category: "Sorveterias",
    icon: <IceCream className="w-8 h-8" />,
    color: "bg-pink-600",
    items: [
      { name: "Meister Sorvetes", number: "(45) 98810-0324", whatsapp: "https://wa.me/5545988100324", address: "Av. Adolfo Chagas, Catanduvas PR" },
      { name: "Nina Sorvetes", number: "Não informado", address: "Av. Paraná, 551, Catanduvas PR" },
      { name: "Sorveteria Lunar", number: "Não informado", address: "Av. Oito de Dezembro, Bairro Alto Alegre, Catanduvas PR" },
    ]
  },
  {
    id: "bolos-doces",
    category: "Bolos e Doces",
    icon: <Cake className="w-8 h-8" />,
    color: "bg-rose-600",
    items: [
      { name: "Isa Rossetto Doces", number: "(45) 99933-0351", whatsapp: "https://wa.me/5545999330351", address: "Av. dos Pioneiros, 608, Centro, Catanduvas PR" },
    ]
  },
  {
    id: "supermercados",
    category: "Supermercados",
    icon: <ShoppingCart className="w-8 h-8" />,
    color: "bg-blue-600",
    items: [
      { name: "Mercado Taxa", number: "(45) 99149-7738", whatsapp: "https://wa.me/5545991497738", address: "Av. dos Pioneiros, 651, Centro, Catanduvas PR" },
      { name: "Aliança Mercado e Materiais de Construção", number: "(45) 3234-1261", whatsapp: "https://wa.me/554532341261", address: "Av. dos Pioneiros, 537, Catanduvas PR" },
      { name: "Supermercado Kapus", number: "(45) 99942-6180", whatsapp: "https://wa.me/5545999426180", address: "Av. dos Pioneiros, 1279, Catanduvas PR" },
      { name: "Supermercado Alto Alegre", number: "(45) 99146-0972", whatsapp: "https://wa.me/5545991460972", address: "Av. Adolfo Chagas, Catanduvas PR" },
      { name: "Mercado Ideal", number: "(45) 3234-1765", whatsapp: "https://wa.me/554532341765", address: "Av. Paraná, 322, Catanduvas PR" },
    ]
  }
].sort((a, b) => a.category.localeCompare(b.category));
